import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Table from "./Table"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getProduct } from "store/products/actions"
import Skeleton from "react-loading-skeleton"
import Breadcrumb from "components/Common/Breadcrumb"

export default function MasterProducts() {
  const history = useHistory()
  const dispatch = useDispatch()
  const store = useSelector(({ products }) => products)
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
  })
  const [count, setCount] = useState(1)

  useEffect(() => {
    setCount(store?.data?.totalPages)
    // if (store?.data?.content?.length) {
    //   const { content } = store.data
    //   const _tableData = content.map((item, idx) => ({
    //     ...item,
    //     idx: idx + 1 + page * 10,
    //   }))
    //   setTableData(_tableData)
    // }
  }, [store?.data])

  const [filter, setFilter] = useState({
    productName: "",
  })

  const params = {
    productName: filter.productName,
    page: pagination.page,
    size: pagination.size,
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    dispatch(getProduct({ ...params, page: 0, size: 10 }))
  }

  useEffect(() => {
    dispatch(getProduct(params))
  }, [dispatch])

  useEffect(() => {
    dispatch(getProduct(params))
  }, [pagination])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"商品マスター"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={3}>
                <TextInputWithLabel
                  label={"商品名"}
                  placeholder={""}
                  value={filter.productName}
                  type="text"
                  name="name"
                  onChange={e => {
                    setFilter({ ...filter, productName: e.target.value })
                    setPage(0)
                  }}
                />
              </Col>
              <Col md={3} className="d-flex align-content-end flex-wrap">
                <SButton onClick={onSearch} className="mx-2 button">
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row className="mt-3">
              <div className="d-flex justify-content-end align-self-end mb-3">
                <SButton
                  className="button"
                  onClick={() => history.push("/master/product/create")}
                >
                  新規追加
                </SButton>
              </div>
              <Col md={12}>
                {store.status === "process" ? (
                  <Skeleton count={5} />
                ) : (
                  <>
                    <Table
                      page={pagination.page}
                      size={pagination.size}
                      count={count}
                      content={store?.data?.content}
                      params={pagination}
                      setParams={setPagination}
                    />
                  </>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
